import type { AlertsState } from './types'

const state = (): AlertsState => ({
  notifications: []
})

export default state
